<template>
  <div class="messagereply">
    <!-- 评论回复 -->
    <div class="userInfoInside">
      <div class="userInfo">
        <div class="messagereply_userInfo_left">
          <img :src="commentListReplyData.memberAvatar" @error="defImg()" alt=""
            @click="goUserPage(commentListReplyData.memberId)" />
          <div class="message_leftbox_img_icon"
            :class="commentListReplyData.memberAuthInfo && commentListReplyData.isOfficial == 0 ? 'memberAuthInfoFlag' : ''"
            v-show="commentListReplyData.isOfficial == 1 || commentListReplyData.isOfficial == 2 || commentListReplyData.isOfficial == 3 || commentListReplyData.memberAuthInfo">
          </div>
          <p class="username messagereply_user" @click="replyUser(commentListReplyData)">
            <span class="messagereply_user_right" :class="
              commentListReplyData.replyMemberNickName
                ? ''
                : 'messagereply_user_rightlong'
            ">{{ commentListReplyData.memberNickName }}</span>
            <span class="messageCon_poster" v-show="
              commentListReplyData.memberId ==
              commentListReplyData.postsPosterId
            ">楼主</span>
            <span class="username_text" v-show="commentListReplyData.replyMemberNickName">回复</span>
            <span class="messagereply_user_right">{{
              commentListReplyData.replyMemberNickName
            }}</span>
          </p>
        </div>

        <div v-show="!sharePage" class="details_comments_top_extension" @click="vanActionFlag(commentListReplyData)">
          ...
        </div>
      </div>
      <p class="msg" @click="replyUser(commentListReplyData)" v-html="commentListReplyData.content"></p>
      <div class="userInfoInside_bottom">
        <p class="msgTime">{{ commentListReplyData.createTime }}</p>
        <div class="likeWrap level2" @click="lickClick" :data-id="commentListReplyData.id">
          <div class="card_lickbtn" :class="
            this.isLike || likeClickFlag
              ? 'publicAction_curgoodicon'
              : 'publicAction_goodicon'
          " ref="level2_lickbtn"></div>
          <span v-show="commentListReplyData.likeNum > 0">{{
            commentListReplyData.likeNum
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import get from "@/api/get";
import numberFormat from "@/utils/numberFormat";
import getTime from '@/utils/time.js'
import { Icon, Tab, Tabs, ActionSheet, Toast, Popover, Button } from "vant";
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(ActionSheet);
Vue.use(Popover);
export default {
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
  },
  props: {
    commentListReplyData: {
      type: Object,
      default: () => { },
    },
    sharePage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultImg: this.$store.state.gameType != 1 ? "https://media.tentree-games.com/media/pictures/community/img/header.webp" :
        "https://media.zlongame.com/media/pictures/cn/community/img/lzg_header.png",
      isLike: "",
      likeClickFlag: "",
      show: false,
    };
  },
  mounted() {
    let _obj = [];
    _obj[0] = this.commentListReplyData;
    getTime(_obj)
    this.isLike = this.commentListReplyData.isLike;
    this.commentListReplyDataCurrent = this.commentListReplyData;
    this.commentListReplyData.likeNum = numberFormat(
      this.commentListReplyData.likeNum
    );
  },
  methods: {
    defImg() {
      //图片错误展示默认图片
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    //扩展点击
    vanActionFlag(item) {
      this.$emit("vanActionFlag", item);
    },
    //回复评论
    replyUser(item) {
      // console.log(item);
      this.$emit("replyUser", item, 1);
    },
    goUserPage(id) {
      this.$emit("goUserPage", id);
    },
    onSelect(item) {
      this.show = false;
      Toast(item.name);
    },
    onCancel() {
      Toast("取消");
    },
    onSelectAction(action) {
      Toast(action.text);
    },
    likeChang() {
      this.likeClickFlag = this.isLike == 1 ? true : false;
      this.isLike = this.isLike == 1 ? 0 : 1;
      this.likeClickFlag = !this.likeClickFlag;
      if (!this.isLike)
        this.commentListReplyData.likeNum =
          this.commentListReplyData.likeNum-- <= 0
            ? 0
            : this.commentListReplyData.likeNum--;
      else this.commentListReplyData.likeNum++;
    },
    lickClick(e) {
      if (this.sharePage) return;
      let likeId = {
        id: e.currentTarget.dataset.id,
      };

      get.commentLikeClick(likeId.id).then((res) => {
        let data = res.data;
        if (data.message == "点赞成功") {
          this.$refs.level2_lickbtn.style.width = ".8rem";
          this.$refs.level2_lickbtn.style.height = ".8rem";
          this.$refs.level2_lickbtn.style.backgroundPosition = "right";
          this.$refs.level2_lickbtn.style.transition = `background .6s steps(28)`;
          setTimeout(() => {
            this.$refs.level2_lickbtn.style.width = ".8rem";
            this.$refs.level2_lickbtn.style.height = ".8rem";
            this.$refs.level2_lickbtn.style.backgroundPosition = "left";
            this.$refs.level2_lickbtn.style.transition = `none`;
            this.likeChang();
          }, 600);
        } else {
          this.likeChang();
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
